/**
 * Adapptio core library.
 *
 * @package core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export class TranslateResolver {
	// @todo change when Translator class will be implemented
	public translate(t: string): string {
		return t;
	}
}
